var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", [
    _c(
      "div",
      { staticClass: "header" },
      [
        _c("div", { staticClass: "header__inner" }, [
          _c("div", { staticClass: "header__row J_headerRow" }, [
            _c("div", { staticClass: "header__nav" }, [
              _c("div", { staticClass: "header__nav-items--left" }, [
                _c("div", { staticClass: "header__company" }, [
                  _c("img", {
                    staticClass: "header__logo",
                    attrs: {
                      src:
                        "https://www.honor.com/content/dam/honor/common/logo/honor-logo-black.svg"
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "header__button--right" }, [
                    _c("i", {
                      staticClass:
                        "iconfont icon-yingyongzhongxin header__icon-fenlei",
                      on: { click: _vm.openNavItems }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "header__links J__headerLinks",
                    attrs: { role: "menubar" }
                  },
                  [
                    _c(
                      "li",
                      { staticClass: "header__link-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "header__router-link",
                            attrs: { to: "/home", exact: "" }
                          },
                          [_vm._v(" 首页 ")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "header__link-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "header__router-link",
                            attrs: { to: "/report", exact: "" }
                          },
                          [_vm._v("提交漏洞 ")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "header__link-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "header__router-link",
                            attrs: { to: "/ranking", exact: "" }
                          },
                          [_vm._v("英雄榜 ")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "header__link-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "header__router-link",
                            attrs: { to: "/announcement" }
                          },
                          [_vm._v("公告 ")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "header__link-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "header__router-link",
                            attrs: { to: "/aboutUs" }
                          },
                          [_vm._v("关于我们 ")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "header__link-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "header__router-link is-hidden J_userCenter",
                            attrs: { to: "/usercenter" }
                          },
                          [_vm._v("个人中心 ")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("li", { staticClass: "header__link-item" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "header__router-link is-hidden J__loginOutButton",
                          attrs: { href: "javascript: void(0);" },
                          on: {
                            click: function($event) {
                              return _vm.handleCommand("out")
                            }
                          }
                        },
                        [_vm._v("退出登录")]
                      )
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "header__user" },
              [
                _c(
                  "a",
                  {
                    staticClass: "header__login-button J__loginButton",
                    attrs: { id: "hwlogin", href: "javascript: void(0);" },
                    on: { click: _vm.loginHandle }
                  },
                  [_vm._v("登录")]
                ),
                _vm._v(" "),
                _c(
                  "xui-dropdown",
                  {
                    staticClass:
                      "header__user-select is-hidden J_headerUserSelect",
                    attrs: { trigger: _vm.PcEnd ? "hover" : "click" },
                    on: { command: _vm.handleCommand }
                  },
                  [
                    _c("div", { staticClass: "header__user-info" }, [
                      _c("div", { staticClass: "header__user-account" }, [
                        _c("span", { staticClass: "header__user-name" }, [
                          _vm._v(_vm._s(_vm.user.displayName))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "header__user-portrait" },
                        [
                          _vm.user.headPictureUrl
                            ? [
                                _c("img", {
                                  staticClass: "header__user-pic",
                                  attrs: {
                                    src:
                                      "https://" +
                                      this.$baseU +
                                      ".honor.com/hsrc/vul/gateway/vul/hsrc/vul/report/servlet/res/image?attachmentId=" +
                                      _vm.user.headPictureUrl
                                  }
                                }),
                                _vm._v(" "),
                                _vm.unReadSiteMsgCount &&
                                _vm.unReadSiteMsgCount > 0
                                  ? _c(
                                      "span",
                                      { staticClass: "header__msg-count" },
                                      [_vm._v(_vm._s(_vm.unReadSiteMsgCount))]
                                    )
                                  : _vm._e()
                              ]
                            : [
                                _c("i", {
                                  staticClass:
                                    "iconfont icon-bianzubeifen header__user-pic--default"
                                })
                              ]
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "xui-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _c(
                          "xui-dropdown-item",
                          {
                            staticClass: "header__user-select-item",
                            attrs: { "default-actived": "", command: "info" }
                          },
                          [
                            _c("img", {
                              staticClass: "header__user-select-img",
                              attrs: {
                                src: require("../images/modify_userinfo-icon.png")
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("个人资料")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "xui-dropdown-item",
                          {
                            staticClass: "header__user-select-item",
                            attrs: { command: "infoId" }
                          },
                          [
                            _c("img", {
                              staticClass: "header__user-select-img",
                              attrs: {
                                src: require("../images/authenticate-icon.png")
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("身份认证")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "xui-dropdown-item",
                          {
                            staticClass: "header__user-select-item",
                            attrs: { command: "report" }
                          },
                          [
                            _c("img", {
                              staticClass: "header__user-select-img",
                              attrs: {
                                src: require("../images/my_vulnerability-icon.png")
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("我的漏洞")]),
                            _vm._v(" "),
                            _vm.unReadBbsCount && _vm.unReadBbsCount > 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "header__msg-count header__msg-count--drowdown"
                                  },
                                  [_vm._v(_vm._s(_vm.unReadBbsCount))]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "xui-dropdown-item",
                          {
                            staticClass: "header__user-select-item",
                            attrs: { command: "message" }
                          },
                          [
                            _c("img", {
                              staticClass: "header__user-select-img",
                              attrs: {
                                src: require("../images/msg_center-icon.png")
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("消息中心")]),
                            _vm._v(" "),
                            _vm.unReadMsgListCount && _vm.unReadMsgListCount > 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "header__msg-count  header__msg-count--drowdown"
                                  },
                                  [_vm._v(_vm._s(_vm.unReadMsgListCount))]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "xui-dropdown-item",
                          {
                            staticClass: "header__user-select-item",
                            attrs: { command: "teamMenu" }
                          },
                          [
                            _c("img", {
                              staticClass: "header__user-select-img",
                              attrs: { src: require("../images/teamPic.png") }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("团队菜单")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "xui-dropdown-item",
                          {
                            staticClass: "header__user-select-item",
                            attrs: { command: "out" }
                          },
                          [
                            _c("img", {
                              staticClass: "header__user-select-img",
                              attrs: {
                                src: require("../images/logout-icon.png")
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("退出登录")])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _vm.isEffect
          ? _c(
              "xui-dialog",
              {
                staticClass: "login-dialog",
                attrs: {
                  title: "失效提醒",
                  "append-to-body": "true",
                  "close-on-click-modal": false,
                  showcenter: "",
                  visible: _vm.isEffect,
                  width: "30%"
                },
                on: {
                  "update:visible": function($event) {
                    _vm.isEffect = $event
                  },
                  close: function($event) {
                    _vm.isEffect = false
                  }
                }
              },
              [
                _c("span", [_vm._v("您的账号已经失效，请联系管理员")]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer", center: "" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "xui-button",
                      {
                        attrs: { type: "primary", size: "bigger" },
                        on: {
                          click: function($event) {
                            _vm.isEffect = false
                          }
                        }
                      },
                      [_vm._v("关闭")]
                    )
                  ],
                  1
                )
              ]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header__company-info" }, [
      _c("div", { staticClass: "header__company-name--cn" }, [
        _vm._v("荣耀安全应急响应中心")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "header__company-name--en" }, [
        _vm._v("Honor Security Response Center")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61dd7a3d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61dd7a3d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = null
// module chunks = 